import React, { useContext, useEffect, useState } from 'react';
import { TokenMetadata } from '../../services/ft-contract';
import { toInternationalCurrencySystemLongString } from 'src/utils/numbers';
import { toPrecision } from '../../utils/numbers';
import { SingleToken } from './SelectToken';
import { RefIcon } from '../icon/DexIcon';
import { TriIcon } from '../icon/DexIcon';
import { WalletContext } from '../../utils/wallets-integration';
import { PinEmpty, PinSolid } from '../icon/Common';
import { localTokens, USER_COMMON_TOKEN_LIST } from './SelectToken';
import { WRAP_NEAR_CONTRACT_ID } from '../../services/wrap-near';
interface TokenProps {
  token: TokenMetadata;
  onClick: (token: TokenMetadata) => void;
  totalAmount?: string;
  sortBy?: string;
  price?: string;
  index?: number;
  forCross?: boolean;
  isRisk?: boolean;
}
export function tokenPrice(price: string, error?: boolean) {
  return (
    <span className="text-xs text-primaryText">
      {`$${
        error || !price
          ? '-'
          : toInternationalCurrencySystemLongString(price, 2)
      }`}
    </span>
  );
}
export default function SelectTokenList({
  token,
  onClick,
  sortBy,
  price,
  index,
  forCross,
  isRisk,
}: TokenProps) {
  const { symbol, id, near, onRef, onTri } = token;
  const {
    commonBasesTokens,
    getLatestCommonBasesTokens,
    getLatestCommonBasesTokenIds,
  } = useContext(localTokens);
  const local_user_list = getLatestCommonBasesTokenIds();
  const userTokenIds = new Set(local_user_list);
  const [hasPin, setHasPin] = useState<boolean>();
  const { globalState } = useContext(WalletContext);
  const isSignedIn = globalState.isSignedIn;
  useEffect(() => {
    const pinnedToken = commonBasesTokens.find((token: TokenMetadata) => {
      if (token.id == id && token.symbol == symbol) return true;
    });
    if (pinnedToken) {
      setHasPin(true);
    } else {
      setHasPin(false);
    }
  }, [commonBasesTokens]);
  const displayBalance = isSignedIn
    ? 0 < Number(near) && Number(near) < 0.001
      ? '< 0.001'
      : toPrecision(String(near), 3)
    : '-';

  const [hover, setHover] = useState(false);
  function pinToken(token: TokenMetadata) {
    if (token.id == WRAP_NEAR_CONTRACT_ID && token.symbol == 'NEAR') {
      userTokenIds.add('near');
    } else {
      userTokenIds.add(token.id);
    }
    localStorage.setItem(
      USER_COMMON_TOKEN_LIST,
      JSON.stringify(Array.from(userTokenIds))
    );
    getLatestCommonBasesTokens();
  }
  function removeToken(token: TokenMetadata) {
    if (token.id == WRAP_NEAR_CONTRACT_ID && token.symbol == 'NEAR') {
      userTokenIds.delete('near');
    } else {
      userTokenIds.delete(token.id);
    }
    localStorage.setItem(
      USER_COMMON_TOKEN_LIST,
      JSON.stringify(Array.from(userTokenIds))
    );
    getLatestCommonBasesTokens();
  }
  return (
    <div
      key={id + symbol}
      className="flex items-center justify-between w-full  hover:bg-white hover:bg-opacity-5 relative"
      onClick={() => onClick && onClick(token)}
      style={{
        height: '56px',
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className={`flex items-center cursor-pointer pl-8 xsm:pl-5 xs:text-xs text-sm  ${
          index === 0 ? 'pt-4 pb-2' : 'py-2'
        }`}
      >
        <SingleToken token={token} />
      </div>
      <div
        className={!forCross ? 'hidden' : 'w-12 flex justify-start  absolute '}
        style={{
          left: '52%',
        }}
      >
        {onRef || onTri ? <RefIcon lightTrigger={hover} /> : null}

        {onTri ? <TriIcon lightTrigger={hover} /> : null}
      </div>
      <div
        className={`pr-4 ${
          index === 0 ? 'pt-6 pb-4' : 'py-4'
        } xs:text-xs text-sm w-3/10 text-right ${
          sortBy === 'near' ? 'text-white' : ''
        }`}
      >
        <div className="flex">
          <div className="text-right mr-3">
            <div className="text-sm text-white">{displayBalance}</div>
            <div className="text-xs text-primaryText">
              {price ? tokenPrice(price) : null}
            </div>
          </div>
          {
            <>
              {hasPin ? (
                <PinSolid
                  onClick={(event: any) => {
                    event.stopPropagation();
                    removeToken(token);
                  }}
                  className="text-primaryText hover:text-pinEmptyHoverColor cursor-pointer"
                ></PinSolid>
              ) : (
                <PinEmpty
                  onClick={(event: any) => {
                    event.stopPropagation();
                    pinToken(token);
                  }}
                  className="text-primaryText hover:text-pinEmptyHoverColor cursor-pointer"
                ></PinEmpty>
              )}
            </>
          }
        </div>
      </div>
    </div>
  );
}
